import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/product-supplier`;

export const productSupplierService = {
    getRetailerProducts: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-retailer-products`,{
            params
        })
        .then((response) => {
            return response.data;
        });

    },
    updateRetailerProduct: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-retailer-product`, params)
        .then((response) => {
            return response.data;
        });
    }
}